import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media, colors } from '../styles';
import { Container } from '../components/container';

const propTypes = {
  children: PropTypes.any
};

const Footer = props => {
  const { children } = props;

  return (
    <FooterWrapper>
      <FooterContainer>{children}</FooterContainer>
    </FooterWrapper>
  );
};

Footer.propTypes = propTypes;

const FooterWrapper = styled.div`
  background-color: ${colors.footerBackground};
  color: ${colors.pureWhite};
  min-height: 465px;  
`;

const FooterContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  padding: 60px 80px;
  gap: 60px;

  a {
    color: ${colors.pureWhite};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: ${media.mediumBottom}) {
    padding: 40px 20px;
    flex-direction: column;
    gap: 40px;
  }
`;

export { Footer };
